import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#2A2E3D]/70 py-14 bg-[#0B0D12]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <div className="relative overflow-hidden h-10 w-10 flex-shrink-0">
                <img
                  src="/prospectivly-logo.svg"
                  alt="Prospectivly"
                  className="absolute max-w-none"
                  style={{ height: "72px", width: "108px", left: "-28px", top: "-16px" }}
                />
              </div>
              <span className="font-sans not-italic uppercase text-2xl tracking-tight text-[#EDEDED]">
                prospectivly<span className="text-[#FF4500]">.</span>
              </span>
            </div>
            <p className="text-[#9CA3AF] text-sm max-w-md leading-relaxed">
              A performance-based outbound engine for B2B revenue teams. We
              replace your SDR, ads and lead-gen stack with one fully managed
              system, and put pre-qualified meetings on your calendar.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#9CA3AF] mb-4">
              Engine
            </p>
            <ul className="space-y-3 text-sm text-[#EDEDED]">
              <li><a href="#how-it-works" className="link-hover">How it works</a></li>
              <li><a href="#differentiators" className="link-hover">Differentiators</a></li>
              <li><a href="#comparison" className="link-hover">Comparison</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#9CA3AF] mb-4">
              Proof
            </p>
            <ul className="space-y-3 text-sm text-[#EDEDED]">
              <li><a href="#case-study" className="link-hover">BFSI case study</a></li>
              <li>
                <a
                  href="https://vridhi-home-finance-crm.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-hover"
                >
                  Live demo CRM
                </a>
              </li>
              <li><a href="#faq" className="link-hover">FAQ</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#9CA3AF] mb-4">
              Contact
            </p>
            <ul className="space-y-3 text-sm text-[#EDEDED]">
              <li>
                <a
                  href="mailto:jahnvee@prospectivly.com"
                  data-testid="footer-contact-email"
                  className="link-hover text-[#FF4500] hover:text-[#E03C00] transition-colors"
                >
                  jahnvee@prospectivly.com
                </a>
              </li>
              <li>
                <a href="#book" className="link-hover">Book a demo →</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#2A2E3D]/60 flex flex-wrap justify-between gap-4 text-xs text-[#4B5563]">
          <span>© {new Date().getFullYear()} Prospectivly. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="uppercase tracking-[0.3em] hover:text-[#FF4500] transition-colors"
            >
              Privacy policy
            </Link>
            <span className="uppercase tracking-[0.3em]">Built for revenue teams</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
